import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import DataTable from "./datatable";
import { Button, Grid } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
// import FilterTable from '../components/filtertable';
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import InvestmentOverView from "../investment/investmentOverview";
import DiscountOverView from "../prospect/discountManager";
import TicketOverView from "../prospect/ticketManager";
import {
  addProspectPath,
  addDiscountPath,
  addTicketPath,
  searchFilter,
  handleSort,
  investmentDetailsPath,
  delrequestspath,
} from "../utils/varialbles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import InvRequestTabs from "./invInvestmentRequest";
import InvReviewTabs from "./invInvestmentReview";
import DeleteRequestTab from "../investment/deleterequest";
import Rebalance from "../investment/rebalance";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function InvestmentReviewTabs() {
  const classes = useStyles();
  // let match = useRouteMatch();
  const [value, setValue] = React.useState(0);
  const [props, setProps] = React.useState({});
  const [display, seDisplay] = React.useState(false);
  let history = useHistory();
  const location = useLocation();
  const myparams = location.state;
  const userid = location.userid;

  const handleChange = (event, newValue) => {
    // setAddTab(addPage[newValue])
    setValue(newValue);
  };
  let tabsList = ["Investment Request", "Investment Review", "Rebalance"];
  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedfiltersdata");
    // localStorage.removeItem("selectedinvestorfiltersdata");

    if (myparams && myparams.customer_id) {
      setProps(myparams);
    }
    seDisplay(true);

    // THe below code is the navigate back to rebalance tab
    if (location.userid) {
      if (myparams.tab === "Rebalance") {
        setValue(2);
      }
    }
  }, []);

  const viewInvestmentDetails = (object) => {
    history.push({
      pathname: investmentDetailsPath,
      state: myparams,
    });
  };

  // console.log(location.userid);

  const gotoDelRequests = () => {
    history.push({
      pathname: delrequestspath,
      state: myparams,
      id: location.userid,
    });
  };

  return (
    <div>
      <Grid container>
        <Grid
          container
          style={{ justifyContent: "space-between", marginTop: "10px" }}
        >
           <Grid item xs>
           {location.userid ?<Button
              variant="outlined"
              color="default"
              startIcon={<ArrowBackIosIcon />}
              onClick={viewInvestmentDetails}
            >
              Back
            </Button>: ""}
          </Grid> 

          <Grid item xs>
            <Typography
              color="textPrimary"
              variant="h5"
              style={{ textAlign: "center" }}
            >
              Request Manager
            </Typography>
          </Grid>
          <Grid item xs></Grid>
        </Grid>

        <Grid
          container
          style={{
            justifyContent: "space-between",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Grid item></Grid>
          <Grid item>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              {tabsList.map((text, index) => {
                return text !== "Rebalance" || location.userid ? (
                  <Tab
                    label={text}
                    key={index}
                    {...a11yProps(index)}
                    style={{ borderRadius: 10 }}
                  />
                ) : null;
              })}
            </Tabs>
          </Grid>
          <Grid item>
            {location.userid ? (
              <>
                <p
                  style={{
                    textAlign: "right",
                    marginLeft: "auto",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={gotoDelRequests}
                >
                  DELETED REQUESTS
                </p>
              </>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Grid>

      {display ? (
        <>
          {" "}
          <TabPanel value={value} index={0}>
            <InvRequestTabs props={props} id={location.userid} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <InvReviewTabs props={props} id={location.userid} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Rebalance props={props} id={location.userid} />
          </TabPanel>
          {/* <TabPanel value={value} index={2}>
            <DeleteRequestTab props={props} id={location.userid}/>
          </TabPanel> */}
        </>
      ) : (
        ""
      )}
    </div>
  );
}
export default InvestmentReviewTabs;
